import { useCohort } from '@/components/user-context/helpers/cohorts';

import { CurrentProductJoinableUser } from './current-product-joinable-user';
import { CurrentProductUser } from './current-product-user';
import { ExistingUser } from './existing-user';
import { NewUser } from './new-user';

export const LoggedInConfluenceFree = () => {
	const cohort = useCohort(true);

	if (cohort === 'current-product-user') {
		return <CurrentProductUser />;
	}

	if (cohort === 'current-product-joinable-user') {
		return <CurrentProductJoinableUser />;
	}

	if (cohort === 'new-user') {
		return <NewUser />;
	}

	if (cohort) {
		return <ExistingUser />;
	}

	return null;
};
